import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useFileDownloader from '../../useFileDownloader';

const useDownloadDemoRequest = () => {
    const request = useFileDownloader();
    const [loading, setLoading] = useState(false);

    const onDownloadDemoRequestError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while downloading Demo Request '
        );
    };

    const onDownloadDemoRequestSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success("DemoRequest started downloading");
    };

    const downloadDemoRequest = () => {
        const url: HttpConfig = {
            url: `ba/v1/demo-requests/export`,
            method: 'get',
        };

        request(url, onDownloadDemoRequestSuccess, setLoading, onDownloadDemoRequestError, 'DemoRequest.csv');
    };

    return { downloadDemoRequest, loading };
};

export default useDownloadDemoRequest;

